import { Typography, Box } from "@mui/material";
import { makeStyles } from "@/compat/muiStyles";

const useStyles = makeStyles((theme) => ({
    epic: {
        width: "100%",
        padding: '30px 100px',
        background: theme.palette.title.background,
        color: theme.palette.title.text,
        borderRadius: '10px'
    },
}));

interface EpicProps {
    title?: any;
    main?: any;
    sub?: any;
    buttons?: any[];
}

const Epic = ({ title, main, sub, buttons }: EpicProps) => {
    const classes = useStyles();    

    return (
        <Box display="flex" flexDirection="column" className={classes.epic} alignItems="center" gap="20px" textAlign="center">
            <Typography style={{ fontSize: '2.5em', fontWeight: 'bold' }}>{title}</Typography>
            <Typography variant="body1">{main}</Typography>
            {sub && <Typography variant="body2" style={{ fontStyle: 'italic' }}>{sub}</Typography>}
            {buttons &&
                <Box
                    display="flex"
                    justifyContent="center"
                    flexDirection="row"
                    gap="5px"
                >
                    {buttons.map((button, i) => <Box key={i}>{button}</Box>)}
                </Box>
            }
        </Box>
    );
}

export default Epic;
